<script>
  import { _ } from "../../services/i18n";
  let videoPages = false
  import { fly } from 'svelte/transition'
</script>

<section class="section-pre">
  <video src="/videos/tools.mp4" type="video/mp4" id="video-pre" autoplay muted loop width="1240" border-radius="5px" height="auto"></video>
  <div class="box-pre">
    <h3>{$_("tutorial_pages_title_tools")}</h3>
    <p>{$_("tutorial_pages_text_tools")}</p>
    <div class="line-img">
      <div class="line">
        <img id="clock" src="/icons/clock.svg" alt="clock" />
        <h6>31 segundos</h6>
      </div>
      <img id="short-image" src="/icons/silla.png" alt="chair" />
    </div>
  </div>
</section>

<!-- {#if videoPages}
<section in:fly={{ y: 400, duration: 300 }} out:fly={{ y: 400, duration: 300 }} id="video">
  <div class="close" on:click={() => videoPages = !videoPages}><img src="/icons/close-sim3d-azul4.svg" id="close-video" alt="close" /></div>
  <iframe  src="https://www.youtube.com/embed/t4gH8_Q1oAM?controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</section>
{/if} -->
<style>
  * {
    letter-spacing: 1.7px;
    color: var(--theme-color-4);
  }
</style>